import React from 'react';
import { Helmet } from 'react-helmet';
import BrandingSection from './components/BrandingSection';
import AuthPanel from './components/AuthPanel';
import TrustIndicators from './components/TrustIndicators';

const Login = () => {
  return (
    <>
      <Helmet>
        <title>Entrar - neo-modelos | Geração de Documentos Legais</title>
        <meta 
          name="description" 
          content="Acesse sua conta neo-modelos para gerenciar e gerar documentos legais de forma segura e eficiente." 
        />
      </Helmet>
      <div className="min-h-screen auth-page-bg flex items-center justify-center p-4 md:p-6 lg:p-8">
        <div className="w-full max-w-md lg:max-w-lg">
          <div className="bg-card/95 backdrop-blur-sm rounded-2xl shadow-elevation-xl p-6 md:p-8 lg:p-10 border border-border/80">
            <BrandingSection />
            
            <div className="mt-8 lg:mt-10">
              <AuthPanel />
            </div>

            <TrustIndicators />
          </div>

          <div className="mt-6 text-center">
            <p className="text-xs text-muted-foreground">
              &copy; {new Date()?.getFullYear()} neo-modelos. Todos os direitos reservados.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;